<section class="atw-page my-applies-page">
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>

  <div class="atw-container">
    <div class="section-title">
      <span>
        <b>{{ 'atw.myApplies.sectionNumber' | transloco }}</b>
      </span>

      <div>
        <h2>{{ 'atw.myApplies.title' | transloco }}</h2>
        <p>{{ 'atw.myApplies.subtitle' | transloco }}</p>
      </div>
    </div>

    <div class="applies-toolbar" *ngIf="!isLoading && !errorMessage">
      <strong>
        {{ 'atw.myApplies.count' | transloco: { count: total } }}
      </strong>

      <button type="button" class="refresh-btn" (click)="retryLoad()">
        {{ 'atw.myApplies.refresh' | transloco }}
      </button>
    </div>

    <div *ngIf="isLoading" class="apply-state-card">
      <div class="loader"></div>
      <p>{{ 'atw.myApplies.loading' | transloco }}</p>
    </div>

    <div *ngIf="!isLoading && errorMessage" class="apply-error-card">
      <p>{{ errorMessage }}</p>
      <button type="button" (click)="retryLoad()">
        {{ 'atw.myApplies.retry' | transloco }}
      </button>
    </div>

    <div
      *ngIf="!isLoading && !errorMessage && !applications.length"
      class="apply-state-card"
    >
      <h3>{{ 'atw.myApplies.emptyTitle' | transloco }}</h3>
      <p>{{ 'atw.myApplies.emptyText' | transloco }}</p>
      <button type="button" routerLink="/jobs">
        {{ 'atw.myApplies.browseJobs' | transloco }}
      </button>
    </div>

    <div
      *ngIf="!isLoading && !errorMessage && applications.length"
      class="applications-list"
    >
      <article
        class="application-card"
        *ngFor="let application of applications; trackBy: trackByApplicationId"
      >
        <div class="application-main">
          <span class="application-icon">    <i class="fa-solid fa-briefcase" aria-hidden="true"></i></span>

          <div>
            <h3>{{ getJobTitle(application) }}</h3>
            <p>{{ getCompanyName(application) }}</p>
          </div>
        </div>

        <div class="application-meta">
<span
  class="status-pill"
  [ngClass]="getStatusClass(application.status)"
>
  {{ getStatusLabel(application.status) }}
</span>

          <small>
            {{ 'atw.myApplies.appliedAt' | transloco }}:
            <strong>{{ getApplicationDate(application) }}</strong>
          </small>
        </div>

        <div class="application-details">
          <span>
            {{ 'atw.myApplies.location' | transloco }}:
            <strong>{{ getLocation(application) }}</strong>
          </span>

          <span>
            {{ 'atw.myApplies.applicationId' | transloco }}:
            <strong>#{{ application.id || '-' }}</strong>
          </span>
        </div>

        <div class="application-actions">
          <button type="button" class="secondary-btn" (click)="openJob(application)">
            {{ 'atw.myApplies.viewJob' | transloco }}
          </button>
        </div>
      </article>
    </div>

    <div
      *ngIf="!isLoading && !errorMessage && applications.length && lastPage > 1"
      class="pagination-bar"
    >
      <button
        type="button"
        (click)="goToPage(currentPage - 1)"
        [disabled]="currentPage <= 1"
      >
        {{ 'atw.myApplies.previous' | transloco }}
      </button>

      <span>
        {{ 'atw.myApplies.pageInfo' | transloco: { current: currentPage, total: lastPage } }}
      </span>

      <button
        type="button"
        (click)="goToPage(currentPage + 1)"
        [disabled]="currentPage >= lastPage"
      >
        {{ 'atw.myApplies.next' | transloco }}
      </button>
    </div>
  </div>
</section>
